<div class="flex  items-center gap-10 py-4">
  <div class="toggle-btn">
    <mat-slide-toggle  (change)="onSelectAll($event)"
    [checked]="sectionSelected">Select
      Module</mat-slide-toggle>
  </div>
  <div class="content-top-row mt-0 w-full">
    <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing ml-0 w-100  ">
      <mat-label>Search Menu</mat-label>
      <input matInput [formControl]="searchCtrl" placeholder="Search Menu" #input>
    </mat-form-field>
  </div>
</div>
<table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
  <ng-container *ngFor="let column of columns">
    <ng-container *ngIf="column.type === 'boolean'" [matColumnDef]="column.property">
      <th mat-header-cell *matHeaderCellDef>
        {{column.label}}
      </th>
      <td *matCellDef="let row" mat-cell>
        <mat-slide-toggle (change)="siglePropSelection($event, row?.menuId, column.property)"
         color="accent" [checked]="row[column.property]"></mat-slide-toggle>
      </td>
    </ng-container>
    <ng-container *ngIf="column.type === 'text'" [matColumnDef]="column.property">
      <th mat-header-cell *matHeaderCellDef> {{column.label}} </th>
      <td mat-cell *matCellDef="let row"> {{row[column.property]}} </td>
    </ng-container>
    <ng-container *ngIf="column.type === 'checkbox'" [matColumnDef]="column.property">
      <th mat-header-cell *matHeaderCellDef> {{column.label}} </th>
      <td *matCellDef="let row" mat-cell>
        <mat-checkbox (change)="rowSelection($event, row?.menuId)" 
         color="accent" [checked]="row[column.property]"></mat-checkbox>
      </td>
    </ng-container>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="visibleColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: visibleColumns">
  </tr>

</table>
<mat-paginator [pageSizeOptions]="[ 10, 25, 100]" aria-label="Select page of users"></mat-paginator>